import { Button, Form, Input, Modal, Spin } from 'antd';
import React, { useCallback, useRef, useState } from 'react';
import HistoryListCard from './HistoryListCard';
import { addComment } from '@/api/technical';
import { FAEOrderStatus } from '@/types/technical';
import UploadFile from '@/components/UploadFile';
import { UploadFileStatus } from '@/types/base';


interface HistoryListProps {
  orderDetail: any
  updateDetail?: () => void
  closeOrder?: () => void
}

const prefix = 'fae-order-detail';
const HistoryList: React.FC<HistoryListProps> = (props) => {
  const { orderDetail, updateDetail, closeOrder } = props;
  const [form] = Form.useForm();
  const [open, setOpen] = useState<boolean>(false);//工单采纳弹窗显示
  const [isAddComment, setIsAddComment] = useState(false);//追加评论输入框显示
  const isBtn =orderDetail?.enableFlag && (orderDetail?.status == FAEOrderStatus.PROCESSED);//工单采纳按钮是否显示
  const uploadRef = useRef<any>(null);
  const changeAddComment = (value: boolean) => {
    if (value == isAddComment) return;
    setIsAddComment(value)
  }

  const onFinish = useCallback((values: any) => {
    console.log('Success:',values, orderDetail, isBtn);
    if (values?.content) {
      const uploadFiles = uploadRef.current?.getFiles().filter((v: any) => v.status);
      console.log('onSubmit uploadFiles', uploadFiles);
      if (uploadFiles.some((v: any) => v.status == UploadFileStatus.UPLOADING)) {
        window.message.warning('请等待文件上传完成');
        return;
      }
      const params = {
        parentId: orderDetail?.id,
        content: values?.content,
        fileIds:uploadFiles.map((item: any) => item.fileId)
      }
      addComment(params).then((res: any) => {
        if (res.code == 200) {
          setIsAddComment(false);
          form.resetFields();
          updateDetail && updateDetail();
          window.message.success('追加评论成功');
        } else {
          window.message.error(res.message);
        }
      }).catch((err) => {
        console.error(err);
        if (err?.message) {
          window.message.error(err.message);
        }
      })
    }else{
      window.message.warning('请输入追评描述');
    }
  }, [orderDetail])

  const closeOrderHandle = () => {
    if (isBtn) {
      setOpen(true);
    }
  }

  const handleOk = () => {
    setOpen(false);
    closeOrder && closeOrder();
  }
  return (
    <div className={`${prefix}-history common-list-card`}>
      <div className={`${prefix}-history-header`}>
        <div className={` title`}>历史记录</div>
        {
          orderDetail ? <div className={`${prefix}-history-header-btn`}>
            <div className={`${isBtn ? 'active' : ''}`} onClick={closeOrderHandle}>工单采纳</div>
            <div className={`${isBtn ? 'active' : ''}`} onClick={() => changeAddComment(true)}>追加评论</div>
          </div> : null
        }
      </div>
      <HistoryListCard historyList={orderDetail?.recordVOList}  />

      {
        isAddComment && <div className={`${prefix}-history-add`}>
          <div className={`${prefix}-history-add-label`}>追评描述</div>
          <Form className='common-antd-form' layout='vertical' form={form} onFinish={onFinish}>
            <Form.Item name={'content'}>
              <Input.TextArea
                placeholder="请输入追评描述"
                autoSize={{ minRows: 4, maxRows: 6 }}
                maxLength={256}
              />

            </Form.Item>
            <Form.Item label="附件上传" name="fileIds" style={{ width: '50%' }}>
              <UploadFile
                ref={uploadRef}
                singleSizeLimit={10*1024}
                totalSizeLimit={200*1024}
                isCanUpload={true}
                acceptTip={'仅支持PNG\\PDF\\ZIP\\word\\最大尺寸：10MB'}
                initFile={[]}
                fileConfig={{
                  accept: '.png,.pdf,.zip,.doc,.docx',
                  multiple: true,
                }}
              />
            </Form.Item>

            <div className="questions-right-search-btn" style={{ justifyContent: "flex-end" }}>
              <Button onClick={() => changeAddComment(false)}>取消</Button>
              <Button type="primary" htmlType="submit" >确定</Button>
            </div>
          </Form>
        </div>
      }

      <Modal
        title="确定关闭工单吗？"
        open={open}
        maskClosable={false}
        className={'message-delete-modal modal-warm-icon'}
        centered
        onOk={handleOk}
        onCancel={() => setOpen(false)}
      >
        <p></p>
      </Modal>
    </div>

  );
};

export default React.memo(HistoryList);
